function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.72,
  fill: "#ef9413",
  d: "M206 0L0 416h206z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.72,
  fill: "#e9be00",
  d: "M36 416L126 0h80v416z"
});

function SvgCharityWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 206 416"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDYgNDE2Ij4KICA8cG9seWdvbiBwb2ludHM9IjIwNiwwIDAsNDE2IDIwNiw0MTYiIG9wYWNpdHk9Ii43MiIgZmlsbD0iI2VmOTQxMyIvPgogIDxwb2x5Z29uIHBvaW50cz0iMzYsNDE2IDEyNiwwIDIwNiwwIDIwNiw0MTYiIG9wYWNpdHk9Ii43MiIgZmlsbD0iI2U5YmUwMCIvPgo8L3N2Zz4=";
export { SvgCharityWater as ReactComponent };